var exports = {
  "J": "Octicon_0__65eRxn",
  "i": "Link_0__zN5tGZ",
};

module.exports = exports;
